import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-moving-step4-location',
  templateUrl: './moving-step4-location.component.html',
  styleUrls: ['./moving-step4-location.component.scss']
})
export class MovingStep4LocationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
